import { ThemeProvider as FoundationsThemeProvider } from '@brunommsilva/react-foundations';
import { ThemeOptions } from '@mui/material/styles';
import React from 'react';

interface Props {
  children: React.ReactNode;
}

const lightOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#0d9488', // Premium Teal
    },
    secondary: {
      main: '#f59e0b', // Amber
    },
    error: {
      main: '#e11d48',
    },
    success: {
      main: '#10b981',
    },
    info: {
      main: '#3b82f6',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(0, 0, 0, 0.15) transparent',
        },
        '*::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          background: 'rgba(0, 0, 0, 0.15)',
          borderRadius: '3px',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(0, 0, 0, 0.25)',
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        slotProps: {
          title: {
            variant: 'h6',
            sx: { fontWeight: 700 },
          },
        },
      },
    },
  },
};

const darkOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#0d9488', // Premium Teal
    },
    secondary: {
      main: '#f59e0b', // Amber
    },
    error: {
      main: '#fb7185',
    },
    success: {
      main: '#34d399',
    },
    info: {
      main: '#60a5fa',
    },
    background: {
      default: '#0b0f19',
      paper: '#151c2c',
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(255, 255, 255, 0.15) transparent',
        },
        '*::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          background: 'rgba(255, 255, 255, 0.15)',
          borderRadius: '3px',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(255, 255, 255, 0.25)',
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        slotProps: {
          title: {
            variant: 'h6',
            sx: { fontWeight: 700 },
          },
        },
      },
    },
  },
};

export const ThemeProvider: React.FC<Props> = ({ children }) => {
  return (
    <FoundationsThemeProvider
      lightOptions={lightOptions}
      darkOptions={darkOptions}
    >
      {children}
    </FoundationsThemeProvider>
  );
};

export default ThemeProvider;
